// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"59baba57","79":"59baba57","175":"59baba57","276":"59baba57","312":"5be29cf0","377":"59baba57","468":"7a58b034","474":"59baba57","630":"abc38d0e","637":"8a9e9a6b","672":"7aaaaed7"}[chunkId] + ".chunk.css";
};